import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Full URL: /admissions/:unitId/adminPortal/applicantPipeline
export default store => ({
  path: "applicantPipeline",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/ApplicantPipeline"
    ).then(m => m.default)
  ),
});
